var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "logo-flag display-inline-block",
      style: `--logo-color: ${_vm.logoColor}; --logo-hover-color: ${_vm.logoHoverColor}`,
    },
    [
      _c("font-awesome-icon", {
        attrs: { icon: _vm.$v6.custom.faFontAwesomeLogo, size: _vm.logoSize },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "sr-only" }, [_vm._v(_vm._s(_vm.label))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }